import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Flex, Heading, Layout, ListItem, Text } from '@modusign/design-system';

import { formatContact } from '@app/features/apply-react-signing/libs/formatter/formatContact';

interface InPersonSigningCompleteProps {
  isLastOrder: boolean;
  contactInfo: string;
  participantName: string;
}

export default function InPersonSigningComplete({
  isLastOrder,
  contactInfo,
  participantName,
}: InPersonSigningCompleteProps) {
  return (
    <Flex flexDirection="column">
      <Layout maxWidth="md">
        <Flex
          alignItems="center"
          bg="darkGray600"
          borderRadius="3px"
          flexDirection="column"
          p={10}
          width="100%"
        >
          <Heading
            color="textNeutralLightest"
            fontSize="lg"
            fontWeight="bold"
            mb={6}
            textAlign="center"
          >
            {participantName}님의 서명이 완료되었습니다.
          </Heading>
          <Box
            as="span"
            color="textNeutralLightest"
            fontSize="md"
            fontWeight="regular"
            mb={6}
            sx={{ wordBreak: 'keep-all' }}
            textAlign="center"
          >
            <Text>
              {isLastOrder
                ? '아래 연락처로 문서 다운로드 링크를 전송했습니다.'
                : '모든 서명자의 서명이 완료되면, 아래 연락처로 문서 다운로드 링크가 전송됩니다.'}
            </Text>
          </Box>
          <Box
            backgroundColor="darkGray700"
            borderRadius="3px"
            color="textNeutralLightest"
            mb={6}
            p={6}
            sx={{ wordBreak: 'break-all' }}
            textAlign="center"
            width="100%"
          >
            <Text fontSize="md" fontWeight="medium">
              {participantName} ({formatContact('IN_PERSON', contactInfo)})
            </Text>
          </Box>
          <Box
            backgroundColor="darkGray500"
            borderRadius="3px"
            color="textNeutralUltraLight"
            p={6}
            width="100%"
          >
            <Flex alignItems="center" mb={3}>
              <Text color="iconNeutralBase" display="flex" fontSize="18px" mr={2}>
                <FontAwesomeIcon icon={faCircleExclamation} />
              </Text>
              <Text fontSize="md" fontWeight="medium">
                서명 완료 문서를 꼭 보관해주세요
              </Text>
            </Flex>
            <Box as="ul">
              <ListItem mb={1}>
                <Text fontSize="sm" fontWeight="regular">
                  서명자의 법률적 권익 보호를 위해, 서명 완료 문서를 보관해두는 것이 좋습니다.
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="sm" fontWeight="regular">
                  해당 링크로 30일간 문서 확인 및 다운로드할 수 있습니다.
                </Text>
              </ListItem>
            </Box>
          </Box>
        </Flex>
      </Layout>
      <Layout maxWidth="md" mb={4}>
        <Flex
          alignItems="center"
          bg="darkGray600"
          borderRadius="3px"
          flexDirection="column"
          p={10}
          width="100%"
        >
          <Heading color="textNeutralLightest" fontSize="lg" fontWeight="bold">
            위 내용을 모두 확인한 후 진행자에게 기기를 넘겨주세요.
          </Heading>
        </Flex>
      </Layout>
    </Flex>
  );
}
